module.exports = __webpack_public_path__ + "static/media/search-icon.15ab9b3a.svg";